import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Translation from '@/pages/translation/Translation';
import { useAuth } from '@/hooks/useAuth';

interface HeaderProps {
  onSidebarToggle: () => void;
}

export function Header({ onSidebarToggle }: HeaderProps) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <>
      <header className="sticky top-0 z-50 bg-white/55 dark:bg-gray-900/90 backdrop-blur-sm shadow-md border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between px-6 py-4">
          {/* Left side - Title + Toggle */}
          <div className="flex items-center space-x-4">
            <Button
              onClick={onSidebarToggle}
              variant="outline"
              size="sm"
              className="lg:hidden"
            >
              <Menu size={20} />
            </Button>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Gujarat Competitive Exam Preparation
            </h1>
            {user && <Button
              onClick={() => setOpen(true)}
              variant="outline"
              size="sm"
            >
              Translate
            </Button>}
          </div>

          {/* Right side - Shloka */}
          <div className="text-right text-sm italic text-gray-800 dark:text-gray-300 leading-snug hidden md:block">
            <p>कर्मण्येवाधिकारस्ते मा फलेषु कदाचन ।</p>
            <p>मा कर्मफलहेतुर्भूर्मा ते सङ्गोऽस्त्वकर्मणि ॥</p>
          </div>
        </div>
      </header>
      {open && user && <Translation open={open} onClose={() => setOpen(false)}  />}
    </>
  );
}
